/**
 * Pixelgipfel PDP interactions (M37, überarbeitet m64):
 * - Scroll-Snap-Galerie mit unbegrenzten Medien (Bild/Video/Iframe/3D)
 * - KOMPLETT EVENT-DELEGIERT: Listener hängen am document, nicht an
 *   Elementen — übersteht DOM-Austausch durch Apps/Preview-Bar/Morphing.
 * - Lightbox mit Zoom und Slide-Navigation
 * - Zugängliche Tabs pro [data-pg-tabs]-Instanz
 * - Varianten-Picker (A1): Pills/Selects -> input[name=id], Preis, CTA-Status
 */
(function () {
  'use strict';

  /* ============= Helpers ============= */
  function galleryRoot(el) {
    return el ? el.closest('[data-pg-gallery]') : null;
  }
  function slidesOf(root) {
    return Array.from(root.querySelectorAll('[data-pg-slide]'));
  }
  function currentOf(root) {
    return parseInt(root.dataset.pgCurrent || '0', 10) || 0;
  }

  function scopedTabs(wrap) {
    return Array.from(wrap.querySelectorAll('[role="tab"][data-pg-tab]')).filter(function (tab) {
      return tab.closest('[data-pg-tabs]') === wrap;
    });
  }

  function scopedTabPanels(wrap) {
    return Array.from(wrap.querySelectorAll('[role="tabpanel"][data-pg-tab-panel]')).filter(function (panel) {
      return panel.closest('[data-pg-tabs]') === wrap;
    });
  }

  function tabControlsPanel(tab, panel) {
    var controls = tab.getAttribute('aria-controls');
    var key = tab.getAttribute('data-pg-tab');
    return (controls && panel.id === controls) || panel.getAttribute('data-pg-tab-panel') === key;
  }

  function activateTab(tab, moveFocus) {
    var wrap = tab && tab.closest('[data-pg-tabs]');
    if (!wrap) return;

    var tabs = scopedTabs(wrap);
    var panels = scopedTabPanels(wrap);
    if (tabs.indexOf(tab) === -1 || !panels.some(function (panel) { return tabControlsPanel(tab, panel); })) return;

    tabs.forEach(function (item) {
      var active = item === tab;
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.setAttribute('tabindex', active ? '0' : '-1');
    });

    panels.forEach(function (panel) {
      var active = tabControlsPanel(tab, panel);
      panel.hidden = !active;
      if (active) panel.setAttribute('data-active', 'true');
      else panel.removeAttribute('data-active');
    });

    if (moveFocus) tab.focus();
  }

  function initTabs(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var wraps = [];
    if (scope.matches && scope.matches('[data-pg-tabs]')) wraps.push(scope);
    scope.querySelectorAll('[data-pg-tabs]').forEach(function (wrap) { wraps.push(wrap); });

    wraps.forEach(function (wrap) {
      var tabs = scopedTabs(wrap);
      var panels = scopedTabPanels(wrap);
      if (!tabs.length || !panels.length) return;

      var active = tabs.find(function (tab) {
        return tab.getAttribute('aria-selected') === 'true' && panels.some(function (panel) {
          return tabControlsPanel(tab, panel);
        });
      }) || tabs.find(function (tab) {
        return panels.some(function (panel) { return tabControlsPanel(tab, panel); });
      });

      if (active) activateTab(active, false);
    });
  }

  function updateNav(root, idx) {
    var slides = slidesOf(root);
    idx = Math.max(0, Math.min(slides.length - 1, idx));
    root.dataset.pgCurrent = String(idx);
    var currentEl = root.querySelector('[data-pg-gallery-current]');
    if (currentEl) currentEl.textContent = String(idx + 1);
    var prevBtn = root.querySelector('[data-pg-gallery-prev]');
    var nextBtn = root.querySelector('[data-pg-gallery-next]');
    if (prevBtn) prevBtn.disabled = idx === 0;
    if (nextBtn) nextBtn.disabled = idx === slides.length - 1;
    root.querySelectorAll('[data-pg-gallery-thumb]').forEach(function (t) {
      var ti = parseInt(t.getAttribute('data-pg-gallery-thumb'), 10);
      t.setAttribute('aria-current', ti === idx ? 'true' : 'false');
      if (ti === idx) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    });
    var next = slides[idx + 1];
    if (next) {
      var nextImg = next.querySelector('img');
      if (nextImg && !nextImg.complete) nextImg.loading = 'eager';
    }
  }

  function goTo(root, idx) {
    var main = root.querySelector('[data-pg-gallery-main]');
    var slides = slidesOf(root);
    idx = Math.max(0, Math.min(slides.length - 1, idx));
    var slide = slides[idx];
    if (!main || !slide) return;
    /* Chrome verwirft programmatische Scrolls in snap-mandatory-Containern
       mit scroll-behavior:smooth (resnap zum gemerkten Ziel). Deshalb:
       Snap + Smooth kurz aus, instant springen, dann reaktivieren. */
    main.style.scrollSnapType = 'none';
    main.style.scrollBehavior = 'auto';
    main.scrollLeft = slide.offsetLeft;
    setTimeout(function () {
      main.style.scrollSnapType = '';
      main.style.scrollBehavior = '';
    }, 80);
    updateNav(root, idx);
  }

  /* ============= Varianten-Picker (A1) =============
     * Liest das serverseitig gerenderte Varianten-JSON (<script data-pg-variants>),
     * synchronisiert Pills/Selects -> hidden input[name=id], Preis, CTA-Status
     * und disabled-States. Keine Section-Reloads. */
  function variantSectionRoot(el) {
    return el && el.closest ? el.closest('.pg-pdp') : null;
  }

  function readVariants(root) {
    var el = root.querySelector('script[data-pg-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (_) { return null; }
  }

  function optionGroups(root) {
    return Array.from(root.querySelectorAll('[data-pg-option]'));
  }

  function selectedOptions(root) {
    var sel = {};
    optionGroups(root).forEach(function (group) {
      var pos = group.getAttribute('data-option-position');
      var select = group.querySelector('[data-pg-option-select]');
      if (select) {
        sel[pos] = select.value;
      } else {
        var checked = group.querySelector('[data-pg-option-value][aria-checked="true"]');
        if (checked) sel[pos] = checked.getAttribute('data-value');
      }
    });
    return sel;
  }

  function findVariant(variants, sel) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (sel['1'] && v.option1 !== sel['1']) continue;
      if (sel['2'] && v.option2 !== sel['2']) continue;
      if (sel['3'] && v.option3 !== sel['3']) continue;
      return v;
    }
    return null;
  }

  /* 'available' | 'unavailable' | 'none' — würde diese Wert-Wahl (bei sonst
     aktueller Auswahl) eine existierende/kaufbare Kombi ergeben? */
  function valueState(variants, sel, pos, value) {
    var found = false;
    var avail = false;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok =
        (pos === '1' ? v.option1 === value : (!sel['1'] || v.option1 === sel['1'])) &&
        (pos === '2' ? v.option2 === value : (!sel['2'] || v.option2 === sel['2'])) &&
        (pos === '3' ? v.option3 === value : (!sel['3'] || v.option3 === sel['3']));
      if (ok) {
        found = true;
        if (v.available) avail = true;
      }
    }
    return !found ? 'none' : (avail ? 'available' : 'unavailable');
  }

  /* Spiegelt eine Variante in Pills/Selects/Legenden (für den Init-Fall,
     wenn Liquid keine Auswahl markieren konnte). */
  function syncControlsToVariant(root, variant) {
    if (!variant) return;
    var opts = [variant.option1, variant.option2, variant.option3];
    optionGroups(root).forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-option-position'), 10);
      var val = opts[pos - 1];
      if (val == null) return;
      var select = group.querySelector('[data-pg-option-select]');
      if (select) select.value = val;
      group.querySelectorAll('[data-pg-option-value]').forEach(function (b) {
        var on = b.getAttribute('data-value') === val;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
      });
      var legendSel = group.querySelector('[data-pg-option-selected]');
      if (legendSel) legendSel.textContent = val;
    });
  }

  function updateVariantUI(root, fromUser) {
    var variants = readVariants(root);
    if (!variants) return;
    var sel = selectedOptions(root);
    var form = root.querySelector('form[data-pg-ajax-add]');
    var input = form ? form.querySelector('input[name="id"]') : null;
    var cta = form ? form.querySelector('[type="submit"]') : null;

    /* Init-Fall: keine Gruppe hat eine Auswahl (z.B. älterer Cache ohne
       Liquid-Init). Nicht blind variants[0] nehmen — sonst landet ggf. eine
       ausverkaufte Variante im Formular und der CTA sperrt. Stattdessen die
       serverseitig gesetzte hidden-id im JSON suchen und Controls spiegeln. */
    var selEmpty = true;
    for (var k in sel) { selEmpty = false; break; }
    if (selEmpty && input && input.value) {
      for (var i0 = 0; i0 < variants.length; i0++) {
        if (String(variants[i0].id) === String(input.value)) {
          syncControlsToVariant(root, variants[i0]);
          sel = selectedOptions(root);
          break;
        }
      }
    }

    var variant = findVariant(variants, sel);
    var priceEl = root.querySelector('.pg-pdp__price');
    var compareEl = root.querySelector('[data-pg-price-compare]');

    if (input) input.value = variant ? String(variant.id) : '';

    if (priceEl && variant) priceEl.textContent = variant.price;
    if (compareEl) {
      if (variant && variant.compare_at_price) {
        compareEl.textContent = variant.compare_at_price;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (cta) {
      if (!variant) {
        cta.disabled = true;
        cta.textContent = cta.getAttribute('data-pg-label-unavailable') || 'Nicht verfügbar';
      } else if (!variant.available) {
        cta.disabled = true;
        cta.textContent = cta.getAttribute('data-pg-label-soldout') || 'Ausverkauft';
      } else {
        cta.disabled = false;
        cta.textContent = cta.getAttribute('data-pg-label-add') || 'In den Warenkorb';
      }
    }

    /* Varianten-Titel fürs ATC-Modal (data-pg-variant-title am Formular) */
    if (form) {
      if (variant) {
        var parts = [];
        optionGroups(root).forEach(function (group) {
          var pos = group.getAttribute('data-option-position');
          var name = group.getAttribute('data-pg-option-name') || '';
          var val = sel[pos];
          if (val) parts.push((name ? name + ': ' : '') + val);
        });
        form.setAttribute('data-pg-variant-title', parts.join(' · '));
      } else {
        form.setAttribute('data-pg-variant-title', '');
      }
    }

    /* Event für Sticky-ATC & Co.: Preis/Verfügbarkeit/Variantentitel extern spiegeln */
    root.dispatchEvent(new CustomEvent('pg:variant-changed', {
      bubbles: true,
      detail: {
        id: variant ? String(variant.id) : null,
        price: variant ? variant.price : '',
        compareAt: variant ? variant.compare_at_price : '',
        available: variant ? !!variant.available : false,
        variantTitle: form ? (form.getAttribute('data-pg-variant-title') || '') : ''
      }
    }));

    /* Disabled-/Ausverkauft-States pro Wert-Button */
    optionGroups(root).forEach(function (group) {
      var pos = group.getAttribute('data-option-position');
      group.querySelectorAll('[data-pg-option-value]').forEach(function (btn) {
        var state = valueState(variants, sel, pos, btn.getAttribute('data-value'));
        var none = state === 'none';
        btn.setAttribute('aria-disabled', none ? 'true' : 'false');
        if (none) btn.setAttribute('title', 'Diese Kombination ist nicht verfügbar');
        else btn.removeAttribute('title');
        btn.setAttribute('data-unavailable', state !== 'available' ? 'true' : 'false');
      });
    });

    /* Galerie auf das Varianten-Bild springen (nur bei Nutzer-Aktion) */
    if (fromUser && variant && variant.featured_media) {
      var gal = root.querySelector('[data-pg-gallery]');
      if (gal) {
        var slides = slidesOf(gal);
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(variant.featured_media)) {
            goTo(gal, i);
            break;
          }
        }
      }
    }
  }

  function selectOptionButton(btn) {
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var group = btn.closest('[data-pg-option]');
    if (!group) return;
    group.querySelectorAll('[data-pg-option-value]').forEach(function (b) {
      b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
      b.setAttribute('tabindex', b === btn ? '0' : '-1');
    });
    var legendSel = group.querySelector('[data-pg-option-selected]');
    if (legendSel) legendSel.textContent = btn.getAttribute('data-value');
    var root = variantSectionRoot(btn);
    if (root) updateVariantUI(root, true);
  }

  function initVariantPickers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var roots = [];
    if (scope.matches && scope.matches('.pg-pdp')) roots.push(scope);
    scope.querySelectorAll('.pg-pdp').forEach(function (r) { roots.push(r); });
    roots.forEach(function (r) {
      if (r.querySelector('script[data-pg-variants]')) updateVariantUI(r, false);
    });
  }

  /* ============= Delegierte Klicks ============= */
  document.addEventListener('click', function (e) {
    var t = e.target;

    /* Varianten-Picker: Wert-Pills (Radio-Semantik) */
    var optBtn = t.closest && t.closest('[data-pg-option-value]');
    if (optBtn) {
      if (optBtn.getAttribute('aria-disabled') === 'true') return;
      selectOptionButton(optBtn);
      return;
    }

    /* Galerie: Thumbs / Prev / Next / Fullscreen / Bild-Zoom */
    var thumb = t.closest && t.closest('[data-pg-gallery-thumb]');
    if (thumb) {
      var r1 = galleryRoot(thumb);
      if (r1) goTo(r1, parseInt(thumb.getAttribute('data-pg-gallery-thumb'), 10));
      return;
    }
    var prev = t.closest && t.closest('[data-pg-gallery-prev]');
    if (prev) {
      var r2 = galleryRoot(prev);
      if (r2) goTo(r2, currentOf(r2) - 1);
      return;
    }
    var next = t.closest && t.closest('[data-pg-gallery-next]');
    if (next) {
      var r3 = galleryRoot(next);
      if (r3) goTo(r3, currentOf(r3) + 1);
      return;
    }
    var fsBtn = t.closest && t.closest('[data-pg-gallery-lightbox]');
    if (fsBtn) {
      var r4 = galleryRoot(fsBtn);
      if (r4) openLightbox(currentOf(r4), slidesOf(r4));
      return;
    }
    var zoomImg = t.closest && t.closest('img[data-pg-zoom-src]');
    if (zoomImg) {
      var slide = zoomImg.closest('[data-pg-slide]');
      var r5 = galleryRoot(zoomImg);
      if (slide && r5) openLightbox(parseInt(slide.getAttribute('data-pg-slide'), 10) || 0, slidesOf(r5));
      return;
    }

    /* Lightbox: Close / Prev / Next / Backdrop / Zoom */
    if (t.closest && t.closest('[data-pg-lightbox-close]')) { closeLightbox(); return; }
    if (t.closest && t.closest('[data-pg-lightbox-prev]')) {
      lightboxState.index = Math.max(0, lightboxState.index - 1);
      renderLightboxSlide();
      return;
    }
    if (t.closest && t.closest('[data-pg-lightbox-next]')) {
      lightboxState.index = Math.min(lightboxState.slides.length - 1, lightboxState.index + 1);
      renderLightboxSlide();
      return;
    }
    var lb = document.querySelector('[data-pg-lightbox]');
    if (lb && lightboxState.open && (t === lb || (t.classList && t.classList.contains('pg-lightbox__stage')))) {
      closeLightbox();
      return;
    }

    /* Tabs: generisch und pro [data-pg-tabs]-Instanz gekapselt */
    var tab = t.closest && t.closest('[role="tab"][data-pg-tab]');
    if (tab) {
      activateTab(tab, false);
      return;
    }
  });

  /* Varianten-Picker: <select> bei mehr als 6 Werten */
  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('[data-pg-option-select]');
    if (!select) return;
    var group = select.closest('[data-pg-option]');
    var legendSel = group ? group.querySelector('[data-pg-option-selected]') : null;
    if (legendSel) legendSel.textContent = select.value;
    var root = variantSectionRoot(select);
    if (root) updateVariantUI(root, true);
  });

  /* ============= Swipe/Scroll → aktiven Slide nachführen ============= */
  var scrollTimers = new WeakMap();
  document.addEventListener('scroll', function (e) {
    var main = e.target;
    if (!main || !main.matches || !main.matches('[data-pg-gallery-main]')) return;
    var root = galleryRoot(main);
    if (!root) return;
    clearTimeout(scrollTimers.get(main));
    scrollTimers.set(main, setTimeout(function () {
      var idx = Math.round(main.scrollLeft / main.clientWidth);
      if (idx !== currentOf(root)) updateNav(root, idx);
    }, 100));
  }, true); /* capture: scroll bubbelt nicht */

  /* ============= Keyboard ============= */
  document.addEventListener('keydown', function (e) {
    if (lightboxState.open) {
      if (e.key === 'Escape') { closeLightbox(); }
      else if (e.key === 'ArrowLeft') {
        lightboxState.index = Math.max(0, lightboxState.index - 1);
        renderLightboxSlide();
      } else if (e.key === 'ArrowRight') {
        lightboxState.index = Math.min(lightboxState.slides.length - 1, lightboxState.index + 1);
        renderLightboxSlide();
      }
      return;
    }

    /* Varianten-Pills: Pfeil-Navigation (Radio-Gruppe, roving tabindex) */
    var optKey = e.target.closest && e.target.closest('[data-pg-option-value]');
    if (optKey) {
      var optGroup = optKey.closest('[data-pg-option]');
      var optBtns = optGroup ? Array.from(optGroup.querySelectorAll('[data-pg-option-value]')).filter(function (b) {
        return b.getAttribute('aria-disabled') !== 'true';
      }) : [];
      var optIndex = optBtns.indexOf(optKey);
      var optNext = optIndex;
      if (optIndex === -1 || !optBtns.length) return;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') optNext = (optIndex - 1 + optBtns.length) % optBtns.length;
      else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') optNext = (optIndex + 1) % optBtns.length;
      else if (e.key === 'Home') optNext = 0;
      else if (e.key === 'End') optNext = optBtns.length - 1;
      else return;
      e.preventDefault();
      optBtns[optNext].focus();
      selectOptionButton(optBtns[optNext]);
      return;
    }

    var tab = e.target.closest && e.target.closest('[role="tab"][data-pg-tab]');
    if (tab) {
      var wrap = tab.closest('[data-pg-tabs]');
      var tabs = wrap ? scopedTabs(wrap) : [];
      var index = tabs.indexOf(tab);
      var nextIndex = index;
      if (index === -1 || !tabs.length) return;

      if (e.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
      else if (e.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
      else if (e.key === 'Home') nextIndex = 0;
      else if (e.key === 'End') nextIndex = tabs.length - 1;
      else return;

      e.preventDefault();
      activateTab(tabs[nextIndex], true);
      return;
    }

    var root = galleryRoot(document.activeElement);
    if (!root) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(root, currentOf(root) - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(root, currentOf(root) + 1); }
    else if (e.key === 'Home') { e.preventDefault(); goTo(root, 0); }
    else if (e.key === 'End') { e.preventDefault(); goTo(root, slidesOf(root).length - 1); }
  });

  /* ============= Lightbox ============= */
  var lightboxState = { open: false, index: 0, slides: [], zoomed: false };

  function openLightbox(idx, slides) {
    var lb = document.querySelector('[data-pg-lightbox]');
    if (!lb) return;
    lightboxState.slides = slides;
    lightboxState.index = idx;
    lightboxState.open = true;
    lb.setAttribute('data-open', 'true');
    lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderLightboxSlide();
  }

  function closeLightbox() {
    var lb = document.querySelector('[data-pg-lightbox]');
    if (!lb) return;
    lb.setAttribute('data-open', 'false');
    lb.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    lightboxState.open = false;
    lightboxState.zoomed = false;
    var stage = lb.querySelector('[data-pg-lightbox-stage]');
    if (stage) stage.innerHTML = '';
  }

  function renderLightboxSlide() {
    var lb = document.querySelector('[data-pg-lightbox]');
    if (!lb) return;
    var stage = lb.querySelector('[data-pg-lightbox-stage]');
    var counter = lb.querySelector('[data-pg-lightbox-current]');
    var slide = lightboxState.slides[lightboxState.index];
    if (!stage || !slide) return;

    if (counter) counter.textContent = String(lightboxState.index + 1);

    var type = slide.getAttribute('data-media-type');
    stage.innerHTML = '';
    lightboxState.zoomed = false;

    var node;
    if (type === 'image') {
      var origImg = slide.querySelector('img');
      var src = origImg ? (origImg.getAttribute('data-pg-zoom-src') || origImg.src) : '';
      node = document.createElement('img');
      node.className = 'pg-lightbox__media';
      node.src = src;
      node.alt = origImg ? origImg.alt : '';
      node.addEventListener('click', toggleZoom);
    } else if (type === 'video') {
      var origVideo = slide.querySelector('video');
      node = document.createElement('video');
      node.className = 'pg-lightbox__media';
      node.controls = true;
      node.autoplay = true;
      node.playsInline = true;
      if (origVideo) Array.from(origVideo.querySelectorAll('source')).forEach(function (s) {
        var newSource = document.createElement('source');
        newSource.src = s.src;
        newSource.type = s.type;
        node.appendChild(newSource);
      });
    } else if (type === 'external_video') {
      var origIframe = slide.querySelector('iframe');
      node = document.createElement('iframe');
      node.className = 'pg-lightbox__media';
      node.src = origIframe ? origIframe.src : '';
      node.allow = 'autoplay; encrypted-media; fullscreen';
      node.style.width = '90vw';
      node.style.height = '50.625vw';
      node.style.maxHeight = '88vh';
    } else if (type === 'model') {
      var origModel = slide.querySelector('model-viewer');
      node = document.createElement('model-viewer');
      node.className = 'pg-lightbox__media';
      if (origModel) node.src = origModel.src;
      node.setAttribute('auto-rotate', '');
      node.setAttribute('camera-controls', '');
      node.setAttribute('ar', '');
      node.style.width = '90vw';
      node.style.height = '80vh';
    }
    if (node) stage.appendChild(node);
  }

  function toggleZoom(e) {
    var img = e.target;
    lightboxState.zoomed = !lightboxState.zoomed;
    img.setAttribute('data-zoomed', lightboxState.zoomed ? 'true' : 'false');
    if (lightboxState.zoomed) {
      var rect = img.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    } else {
      img.style.transformOrigin = 'center center';
    }
  }

  /* ============= Initialer Zustand (Galerie und Tabs) ============= */
  function initGalleries() {
    document.querySelectorAll('[data-pg-gallery]').forEach(function (root) {
      updateNav(root, currentOf(root));
    });
  }

  /* ============= Zuletzt angesehen (Tracker) ============= */
  var RECENT_KEY = 'pg:recent';
  var RECENT_MAX = 10;

  function trackRecentlyViewed() {
    document.querySelectorAll('.pg-pdp[data-product-handle]').forEach(function (el) {
      var handle = el.getAttribute('data-product-handle');
      if (!handle) return;
      try {
        var list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
        list = list.filter(function (h) { return h !== handle; });
        list.unshift(handle);
        localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
      } catch (e) {}
    });
  }

  /* ============= Sticky Add-to-Cart ============= */
  function initStickyAtc(root) {
    root.querySelectorAll('[data-pg-sticky-atc]').forEach(function (bar) {
      if (bar.dataset.pgStickyWired === '1') return;
      bar.dataset.pgStickyWired = '1';

      var pdp = bar.closest('.pg-pdp');
      var sentinel = pdp ? pdp.querySelector('.pg-pdp__ctas') : null;
      var btn = bar.querySelector('[data-pg-sticky-btn]');
      var priceEl = bar.querySelector('[data-pg-sticky-price]');
      var variantEl = bar.querySelector('[data-pg-sticky-variant]');
      var mainCta = pdp ? pdp.querySelector('form[data-pg-ajax-add] [type="submit"]') : null;

      function setVisible(on) {
        bar.hidden = !on;
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        bar.classList.toggle('is-visible', on);
      }

      /* Zeigen, sobald die Kauf-Box nach oben aus dem Viewport scrollt */
      if (sentinel && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            setVisible(!en.isIntersecting && en.boundingClientRect.top < 0);
          });
        }, { threshold: 0 });
        io.observe(sentinel);
      }

      /* Button = Proxy auf den echten Submit-Button (Form-Logik bleibt zentral) */
      if (btn && mainCta) {
        btn.addEventListener('click', function () { mainCta.click(); });
      }

      /* Preis/Variante/Verfuegbarkeit vom Varianten-Picker spiegeln */
      document.addEventListener('pg:variant-changed', function (e) {
        if (!e.detail) return;
        if (priceEl && e.detail.price) priceEl.textContent = e.detail.price;
        if (variantEl) variantEl.textContent = e.detail.variantTitle || '';
        if (btn) {
          btn.disabled = !e.detail.available;
          btn.textContent = e.detail.available
            ? (mainCta ? (mainCta.getAttribute('data-pg-label-add') || 'In den Warenkorb') : 'In den Warenkorb')
            : (mainCta ? (mainCta.getAttribute('data-pg-label-soldout') || 'Ausverkauft') : 'Ausverkauft');
        }
      });
    });
  }

  /* Lange Beschreibung: Vorschau <-> Volltext umschalten */
  function initDescToggle(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-pg-desc]').forEach(function (wrap) {
      if (wrap.dataset.pgDescWired === '1') return;
      wrap.dataset.pgDescWired = '1';

      var btn = wrap.querySelector('[data-pg-desc-toggle]');
      var shortEl = wrap.querySelector('[data-pg-desc-short]');
      var fullEl = wrap.querySelector('[data-pg-desc-full]');
      var label = wrap.querySelector('[data-pg-desc-toggle-label]');
      if (!btn || !shortEl || !fullEl) return;

      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        shortEl.hidden = !expanded;
        fullEl.hidden = expanded;
        if (label) {
          label.textContent = expanded
            ? btn.getAttribute('data-label-more')
            : btn.getAttribute('data-label-less');
        }
      });
    });
  }

  function initPdp(root) {
    initGalleries();
    initTabs(root);
    initVariantPickers(root);
    trackRecentlyViewed();
    initStickyAtc(root && root.querySelectorAll ? root : document);
    initDescToggle(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initPdp(document); });
  } else {
    initPdp(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initPdp(e.target); });
})();
